export const isCommentsModuleAvailable = (
  currentUser,
  flagOnCommentsDisabled,
) => {
  if (!currentUser || flagOnCommentsDisabled) {
    return false;
  }

  return true;
};
